import layout from '@/layout'

export default {
  path: '/application',
  component: layout,
  redirect: '/application/approval',
  name: 'approval',
  meta: {
    title: '应用管理',
    icon: 'application'
  },
  children: [
    {
      path: '/application/approval',
      component: () => import('@/views/application/approval'),
      meta: {
        title: '应用审批',
        icon: 'seal'
      }
    },
    {
      path: '/application/approval/:id',
      component: () => import('@/views/application/approval/info'),
      meta: {
        title: '审批详情'
      }
    }
  ]
}
